import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

console.log('Main.tsx loading...');

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

console.log('Creating React root...');
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

console.log('React app rendered');